import { Modal } from '@systemeio/ui'
import { triggerItems } from 'modules/automation-rules/triggers/constants/trigger-items'
import { AutomationRuleTriggersEnum } from 'modules/automation-rules/triggers/enums/trigger-enum'
import React, { useState } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { AddIcon } from '@systemeio/ui'

interface AddTriggerModalProps {
  isReady: boolean
  onAddTrigger: (trigger: AutomationRuleTriggersEnum) => void
  allowedTriggers?: AutomationRuleTriggersEnum[]
}

const AddTriggerModal = ({ onAddTrigger, isReady, allowedTriggers }: AddTriggerModalProps) => {
  const { t } = useLocoTranslation()
  const [opened, setOpened] = useState(false)

  const filteredTriggers = triggerItems.filter(trigger =>
    allowedTriggers ? allowedTriggers.includes(trigger.slug) : true,
  )

  return (
    <>
      {filteredTriggers.length !== 0 && (
        <button
          disabled={!isReady}
          onClick={() => setOpened(true)}
          className={`group flex self-center rounded-full outline-hidden ${
            !isReady && 'pointer-events-none'
          }`}
        >
          <AddIcon
            className={`${
              !isReady && 'fill-fill-primary/70 animate-pulse'
            } main-transition-colors group-hover:fill-brand-primary group-focus-visible:fill-brand-primary fill-fill-primary h-[30px] w-[30px]`}
          />
        </button>
      )}
      <Modal
        title={t('dashboard.automation_rule.edit.add_trigger')}
        opened={opened}
        onClose={() => setOpened(false)}
      >
        <div className={'flex flex-col gap-5 px-10'}>
          {filteredTriggers.map((trigger, idx) => (
            <button
              onClick={() => {
                onAddTrigger(trigger.slug)
                setOpened(false)
              }}
              key={idx}
              className={`group flex w-full gap-3 text-left outline-hidden ${
                idx !== 0 && 'border-text-secondary/30 border-t pt-5'
              }`}
            >
              <div
                className={
                  '[&>svg]:main-transition-colors [&>svg]:group-hover:fill-brand-primary [&>svg]:group-focus-visible:fill-brand-primary [&>svg]:group-hover:stroke-brand-primary [&>svg]:group-focus-visible:stroke-brand-primary [&>svg]:h-[40x] [&>svg]:w-[40px] w-[40px]'
                }
              >
                {trigger.icon}
              </div>
              <div className={'flex flex-col gap-1'}>
                <span className={'text-text-primary text-[15px] font-bold'}>
                  {t(trigger.title)}
                </span>
                <span>{t(trigger.description)}</span>
              </div>
            </button>
          ))}
        </div>
      </Modal>
    </>
  )
}

export default AddTriggerModal
